<template>
	<div>
		<div v-if="loggedInEmployee.isAdmin">
			<v-card class="mb-4">
				<v-divider></v-divider>

				<v-card-text>
					<v-subheader class="text-xs-left mb-3"
						>This section allows you to control the discussion points that will be added when using the Default Template. The Default Template consists of the items within the Employee's Position Description, the Company's Core Values,
						and the discussion points listed below.
					</v-subheader>

					<employee-position-item-list :position-items="defaultDiscussionPointsFormatted" :show-type-column="true" @onEditPositionItem="onEditDefaultDiscussionPoint" @onDeletePositionItem="onDeleteDefaultDiscussionPoint">
					</employee-position-item-list>

					<employee-position-item-editor
						v-if="defaultDiscussionPointDialog"
						:position-item="editedDefaultDiscussionPoint"
						:performance-review="true"
						:allowed-types="[0, 3]"
						@save="saveDefaultDiscussionPoint"
						@closeEditor="defaultDiscussionPointDialog = false"
					>
					</employee-position-item-editor>
				</v-card-text>
			</v-card>

			<v-footer color="" app height="55">
				<v-spacer></v-spacer>
				<footer-add-btn @click="onAddDefaultDiscussionPoint(3)">Add Discussion Point</footer-add-btn>
			</v-footer>
		</div>
		<div v-else>You do not have access</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import EmployeePositionItemList from '@/components/employee/EmployeePositionItemList';
	import EmployeePositionItemEditor from '@/components/employee/EmployeePositionItemEditor';

	export default {
		components: {
			EmployeePositionItemList,
			EmployeePositionItemEditor
		},
		data() {
			return {
				defaultDiscussionPointDialog: false,
				defaultDiscussionPointDialogType: null,
				editedDefaultDiscussionPointIndex: -1,
				editedDefaultDiscussionPoint: undefined
			};
		},
		created() {
			this.$store.dispatch('setPageTitle', 'Default Template');
		},
		computed: {
			...mapGetters({
				defaultDiscussionPoints: 'defaultDiscussionPoints/defaultDiscussionPoints',
				loggedInEmployee: 'loggedInEmployee'
			}),
			defaultDiscussionPointsFormatted() {
				return this.defaultDiscussionPoints.map((x) => {
					return x.item;
				});
			}
		},
		methods: {
			onEditDefaultDiscussionPoint(defaultDiscussionPoint) {
				this.editedDefaultDiscussionPointIndex = this.defaultDiscussionPointsFormatted.indexOf(defaultDiscussionPoint);
				this.editedDefaultDiscussionPoint = Object.assign({}, defaultDiscussionPoint);
				this.defaultDiscussionPointDialogType = this.editedDefaultDiscussionPoint.type;
				this.defaultDiscussionPointDialog = true;
			},
			onAddDefaultDiscussionPoint(type) {
				this.defaultDiscussionPointDialogType = type;
				this.editedDefaultDiscussionPointIndex = -1;
				this.editedDefaultDiscussionPoint = undefined;
				this.defaultDiscussionPointDialog = true;
			},
			onDeleteDefaultDiscussionPoint(defaultDiscussionPoint) {
				const index = this.defaultDiscussionPoints.indexOf(this.defaultDiscussionPoints.find((x) => x.item.id === defaultDiscussionPoint.id));
				if (confirm('Are you sure you want to delete this discussion point?')) {
					this.$store.dispatch('defaultDiscussionPoints/delete', this.defaultDiscussionPoints[index]).then(
						(response) => {},
						(error) => {
							console.error('Error deleting discussion point');
						}
					);
				}
			},
			saveDefaultDiscussionPoint(item) {
				if (this.editedDefaultDiscussionPointIndex > -1) {
					let model = {
						id: this.defaultDiscussionPoints.find((x) => x.item.id === item.id).id,
						item: item
					};

					this.$store.dispatch('defaultDiscussionPoints/edit', model).then(
						(response) => {},
						(error) => {
							console.error('Error saving Default Discussion Point');
						}
					);
				} else {
					let model = {
						id: null,
						item: item
					};

					this.$store.dispatch('defaultDiscussionPoints/add', model).then(
						(response) => {},
						(error) => {
							console.error('Error saving Default Discussion Point');
						}
					);
				}
			},
			closePositionItemEditor() {
				this.editedPositionDialog = false;
			}
		}
	};
</script>

<style></style>
